import { TRACKERS } from "@/constants/Trackers";
import { Hospitalizations } from "@/features/Patient/MedicalRecords/Hospitalization/Hospitalizations";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/hospitalizations")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_HOSPITALIZATIONS);
  },
});

function RouteComponent() {
  return <Hospitalizations />;
}
